import "./App.css";
import { Link } from "react-router-dom";
import Member from "./SECRETARY.png";

function App() {
  return (
    <>
      <>
        {/* Get Pro Button */}
       
        {/* Header Area */}
        <header className="header">
          {/* Topbar */}
          {/* End Topbar */}
          {/* Header Inner */}
          <div className="header-inner">
            <div className="container">
              <div className="inner">
                <div className="row">
                  <div className="col-lg-3 col-md-3 col-12">
                    {/* Start Logo */}
                    <div className="logo">
                      <a href="index.html">
                        <img src="newlogo.png" id="myimg" alt="#" />
                      </a>
                    </div>
                    {/* End Logo */}
                    {/* Mobile Nav */}
                    <div className="mobile-nav" />
                    {/* End Mobile Nav */}
                  </div>
                  <div className="col-lg-4 col-md-9 col-12">
                    {/* Main Menu */}
                    <div className="main-menu">
                      <nav className="navigation">
                        <ul className="nav menu">
                          <li className="active">
                            <a href="index.html">
                              Home <i className="" />
                            </a>
                          </li>
                          <li >
                            <Link to="/Doctors">
                              Dermatologist <i className="" />
                            </Link>
                          </li>
                          <li >
                            <a href="index.html">
                              Login<i className="" />
                            </a>
                          </li>
                          
                        </ul>
                      </nav>
                    </div>
                    {/*/ End Main Menu */}
                  </div>
                  
                  <div className="col-lg-1 col-8">
                    
                    <div className="get-quote">
                     <btn className="btn">
                         <Link to="/Login">APPOINTMENT</Link>
                      
                      </btn>
                      
                    </div>
                    
                  </div>
                  
                  <div className="col-lg-1 col-8"></div>
                  <div className="col-lg-1 col-8">
                    
                    
                    <div className="get-quote">
                     <btn className="btn">
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;  <Link to="/Scan">DIAGNOSIS</Link>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                      </btn>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*/ End Header Inner */}
        </header>
        {/* Start Feautes */}
        <br />
        <br />
        
        <section className="Feautes section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title">
                  <h2>WE ARE ALWAYS READY TO HELP YOU !</h2>
                  <img src="img/section-img.png" alt="#" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-4 col-12">
                {/* Start Single features */}
                <div className="single-features">
                  <div className="signle-icon">
                    <i className="icofont icofont-eye-alt" />
                  </div>
                  <h3>Upload Image</h3>
                </div>
                {/* End Single features */}
              </div>
              <div className="col-lg-4 col-12">
                {/* Start Single features */}
                <div className="single-features">
                  <div className="signle-icon">
                    <i className="icofont icofont-prescription" />
                  </div>
                  <h3>Disease Details</h3>
                </div>
                {/* End Single features */}
              </div>
              <div className="col-lg-4 col-12">
                {/* Start Single features */}
                <div className="single-features last">
                  <div className="signle-icon">
                    <i className="icofont icofont-stethoscope" />
                  </div>
                  <h3>Medical Treatment</h3>
                </div>
                {/* End Single features */}
              </div>
            </div>
          </div>
        </section>
        <br />

        {/*/ End Feautes */}
        {/* Start Fun-facts */}
        <div id="fun-facts" className="fun-facts section overlay">
          <div className="container">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-12">
                {/* Start Single Fun */}
                <div className="single-fun">
                  <i className="icofont icofont-home" />
                  <div className="content">
                    <span className="counter">7</span>
                    <p>Disease trained</p>
                  </div>
                </div>
                {/* End Single Fun */}
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                {/* Start Single Fun */}
                <div className="single-fun">
                  <i className="icofont icofont-user-alt-3" />
                  <div className="content">
                    <span className="counter">16</span>
                    <p>Dermatologists</p>
                  </div>
                </div>
                {/* End Single Fun */}
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                {/* Start Single Fun */}
                <div className="single-fun">
                  <i className="icofont-simple-smile" />
                  <div className="content">
                    <span className="counter">64</span>
                    <p>Happy Patients</p>
                  </div>
                </div>
                {/* End Single Fun */}
              </div>
              <div className="col-lg-3 col-md-6 col-12">
                {/* Start Single Fun */}
                <div className="single-fun">
                  <i className="icofont icofont-table" />
                  <div className="content">
                    <span className="counter">2</span>
                    <p>Months of Experience</p>
                  </div>
                </div>
                {/* End Single Fun */}
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
        <br />
        {/*/ End Fun-facts */}
        {/* Start Why choose */}
        <section className="why-choose section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title">
                  <h2>
                    PROCEDURE OF SKIN-O-CARE
                    
                  </h2>
                  <img src="img/section-img.png" alt="#" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-12">
                {/* Start Choose Left */}
                <div className="choose-left">
                  <h3>We have the following procedure:</h3>
                  <div className="row">
                    <div className="col-lg-12">
                      <ul className="list">
                        <li>
                          <i className="fa fa-caret-right" />
                          Click or upload a picture.
                        </li>
                        <li>
                          <i className="fa fa-caret-right" />
                          Receive disease name and remedies
                        </li>
                        <li>
                          <i className="fa fa-caret-right" />
                          Option for doctor consultation.
                        </li>
                        <li>
                          <i className="fa fa-caret-right" />
                          Disease data and image sent to dermatologist.
                        </li>
                        <li>
                          <i className="fa fa-caret-right" />
                          Engage in online consultation.
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* End Choose Left */}
              </div>
              <div className="col-lg-6 col-12">
                {/* Start Choose Rights */}
                <div className="choose-right">
                  <div className="video-image">
                    {/* Video Animation */}
                    <div className="promo-video">
                      <div className="waves-block">
                        <div className="waves wave-1" />
                        <div className="waves wave-2" />
                        <div className="waves wave-3" />
                      </div>
                    </div>
                    {/*/ End Video Animation */}
                    <a
                      href="https://youtu.be/MY-B9bBdZFU?feature=shared" target="_blank"
                      className="video video-popup mfp-iframe"
                    >
                      <i className="fa fa-play" />
                     
                    </a>
                  </div>
                </div>

                {/* End Choose Rights */}
              </div>
            </div>
          </div>
        </section>
        {/*/ End Why choose */}

        {/*/ End Why choose */}
        {/* Start Call to action */}
        <section
          className="call-action overlay"
          data-stellar-background-ratio="0.5"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                <div className="content">
                  <h2>Do you need Emergency Medical Care? Call @ 7666132393</h2>
                  <div className="button">
                    <br />
                    <btn className="btn">Contact Now</btn>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/*/ End Call to action */}
        {/*/ End portfolio */}
       
        {/* Pricing Table */}
        <section className="pricing-table section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title">
                  <h2>We Provide You The Best Treatment In Resonable Price</h2>
                  <img src="img/section-img.png" alt="#" />
                </div>
              </div>
            </div>
            <div className="row">
              {/* Single Table */}
              <div className="col-lg-6 col-md-12 col-12">
                <div className="single-table">
                  {/* Table Head */}
                  <div className="table-head">
                    <div className="icon">
                      <i className="icofont-heart-beat" />
                    </div>
                    <h4 className="title">PLUS MEMBERSHIP</h4>
                    <div className="price">
                      <p className="amount">FREE</p>
                    </div>
                  </div>
                  {/* Table List */}
                  <ul className="table-list">
                    <li>
                      <i className="icofont icofont-ui-check" />5 Scans Per Day
                    </li>
                    <li className="cross">
                      <i className="icofont icofont-ui-close" />
                      doctor consultation
                    </li>
                    <li className="cross">
                      <i className="icofont icofont-ui-close" />
                      Emergency service
                    </li>
                  </ul>
                  <div className="table-bottom">
                    <btn className="btn">Book Now</btn>
                  </div>
                  {/* Table Bottom */}
                </div>
              </div>
              {/* End Single Table*/}
              {/* Single Table */}
              <div className="col-lg-6 col-md-12 col-12">
                <div className="single-table">
                  {/* Table Head */}
                  <div className="table-head">
                    <div className="icon">
                      <i className="icofont-heart-beat" />
                    </div>
                    <h4 className="title">PRIME MEMBERSHIP</h4>
                    <div className="price">
                      <p className="amount">
                        ₹99<span>/ Per Month</span>
                      </p>
                    </div>
                  </div>
                  {/* Table List */}
                  <ul className="table-list">
                    <li>
                      <i className="icofont icofont-ui-check" />
                      20 scans per day
                    </li>
                    <li>
                      <i className="icofont icofont-ui-check" />
                      doctor consultation
                    </li>
                    <li>
                      <i className="icofont icofont-ui-check" />
                      Emergency service
                    </li>
                  </ul>
                  <div className="table-bottom">
                    <btn className="btn">Book Now</btn>
                  </div>
                  {/* Table Bottom */}
                </div>
              </div>
              {/* End Single Table*/}
            </div>
          </div>
        </section>
        {/*/ End Pricing Table */}
        {/* Start clients */}
       
       <img src={Member} style={{ width: '1600px', height: '600px' }} />
        {/*/Ens clients */}
        {/* Start Appointment */}
        <section className="appointment">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title">
                  <h2>We Are Ready to accept your query</h2>
                  <img src="img/section-img.png" alt="#" />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12 col-md-12 col-12">
                <form className="form" action="#">
                  <div className="row">
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <input name="name" type="text" placeholder="Name" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <input name="email" type="email" placeholder="Email" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <input name="phone" type="text" placeholder="Phone" />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <div
                          className="nice-select form-control wide"
                          tabIndex={0}
                        >
                          <span className="current">Department</span>
                          <ul className="list">
                            <li data-value={1} className="option selected ">
                              Department
                            </li>
                            <li data-value={2} className="option">
                              Cardiac Clinic
                            </li>
                            <li data-value={3} className="option">
                              Neurology
                            </li>
                            <li data-value={4} className="option">
                              Dentistry
                            </li>
                            <li data-value={5} className="option">
                              Gastroenterology
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <div
                          className="nice-select form-control wide"
                          tabIndex={0}
                        >
                          <span className="current">Doctor</span>
                          <ul className="list">
                            <li data-value={1} className="option selected ">
                              Doctor
                            </li>
                            <li data-value={2} className="option">
                              Dr. Akther Hossain
                            </li>
                            <li data-value={3} className="option">
                              Dr. Dery Alex
                            </li>
                            <li data-value={4} className="option">
                              Dr. Jovis Karon
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-12">
                      <div className="form-group">
                        <input type="text" placeholder="Date" id="datepicker" />
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-12">
                      <div className="form-group">
                        <textarea
                          name="message"
                          placeholder="Write Your Message Here....."
                          defaultValue={""}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-7 col-md-4 col-12">
                      <div className="form-group">
                        <div className="button">
                          <button type="submit" className="btn">
                            Submit Query
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        {/* End Appointment */}
       
        {/* Footer Area */}
        <footer id="footer" className="footer ">
          {/* Footer Top */}
       
          {/*/ End Footer Top */}
          {/* Copyright */}
          <div className="copyright">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-12">
                  <div className="copyright-content">
                    <p>
                      © Copyright 2024 | All Rights Reserved by{" "}
                      <a
                        href="https://linktr.ee/taufeeq62"
                        target="_blank"
                        rel="noreferrer"
                      >
                        Skin-O-Care
                      </a>{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*/ End Copyright */}
        </footer>
        {/* jquery Min JS */}
        {/* jquery Migrate JS */}
        {/* jquery Ui JS */}
        {/* Easing JS */}
        {/* Color JS */}
        {/* Popper JS */}
        {/* Bootstrap Datepicker JS */}
        {/* Jquery Nav JS */}
        {/* Slicknav JS */}
        {/* ScrollUp JS */}
        {/* Niceselect JS */}
        {/* Tilt Jquery JS */}
        {/* Owl Carousel JS */}
        {/* counterup JS */}
        {/* Steller JS */}
        {/* Wow JS */}
        {/* Magnific Popup JS */}
        {/* Counter Up CDN JS */}
        {/* Bootstrap JS */}
        {/* Main JS */}
      </>
    </>
  );
}

export default App;
